import React, { useCallback, useEffect, useMemo, useState } from "react";
import CommonHeader from "@shark/micro-components/react/Header";
import "@shark/micro-components/react/Header.css";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useRecoilValue, useRecoilState } from "recoil";
import { ThemeSelector, LocaleSelector } from "store/data/Base";
import { ThemeEnum } from "@app/utils/constants";
import { UserState, UserFullInfoState } from "store/data/User";
import { CurrencyUnitSelector } from "store/v2/Currency";
import LocalCookie, { CookieKey } from "util/LocalCookie";
import Drawer from "rc-drawer";
import SettingDialog from "components/dialogs/NewSetting";
import "./index.css";
import "../NewHeader/HeaderDefault/index.css";
import styles from './index.module.less'

const Header = () => {
  const locale = useRecoilValue(LocaleSelector);
  const userInfo = useRecoilValue(UserState);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [scrollTopEd, setScrollTopEd] = useState<boolean>(false)

  // userFullInfo是userInfo的包裹层
  const userFullInfo = useRecoilValue(UserFullInfoState);
  const [themeState, setThemeState] = useRecoilState(ThemeSelector);
  const [currency, setCurUnit] = useRecoilState(CurrencyUnitSelector);

  const onJump = useCallback((href: string) => {
    location.href = href;
  }, []);

  // pathname: "/en/trading-bot/spot/BTCUSDT"
  let pathParams = useLocation();
  // locales: "en"
  let urlParams = useParams();
  let navigate = useNavigate();

  const handleLangChange = ({ locale: key }: { locale: string }) => {
    LocalCookie.set(CookieKey.LANG, key);
    let { locales } = urlParams;
    let { pathname } = pathParams;
    navigate(`/${key}${pathname.replace(`/${locales}`, "")}`, {
      replace: true,
    });
  };

  const onLogout = () => {
    window.location.reload();
  };
  const handleSetUp = () => {
    console.log("handleSetUp");
    setDrawerVisible(true);
  };
  // 切换主题
  const onThemeChange = useCallback(
    (theme: "black" | "white") => {
      setThemeState(ThemeEnum[theme]);
    },
    [setThemeState]
  );

  // header主题属性
  const themeProperty = useMemo(
    () =>
      [ThemeEnum.black, ThemeEnum.dark].includes(themeState)
        ? ThemeEnum.black
        : ThemeEnum.white,
    [themeState]
  );
  const onCurrencyChange = useCallback(
    ({ type }: { type: string }) => {
      setCurUnit(type);
    },
    [setCurUnit]
  );

  const handleScroll = useCallback(() => {
      //滚动条高度
      const scrollTop = document.documentElement.scrollTop //滚动条滚动高度
      if (scrollTop > 0) {
          setScrollTopEd(true)
      } else {
          setScrollTopEd(false)
      }
  }, [])

  useEffect(() => {
      window.addEventListener('scroll', handleScroll)
      return () => {
          window.removeEventListener('scroll', handleScroll)
      }
  }, [handleScroll])
  return (
    <>
      <div id="blog-header-container"
        className={`${styles.headerContainer} ${scrollTopEd ? styles.scrollTopEd : ''}`}
        >
        <CommonHeader
          locale={locale || "en"}
          theme={themeProperty}
          currency={currency}
          userInfo={userInfo?.userId ? userInfo : undefined}
          userResult={userInfo?.userId ? userFullInfo : undefined}
          enableMultiTheme={true}
          push={onJump}
          themeChange={onThemeChange}
          languageChange={handleLangChange}
          currencyChange={onCurrencyChange}
          project="events"
          logout={onLogout}
          // noInMail={true}
          isShowSetUp={true}
          handleSetUp={handleSetUp}
        />
      </div>
      {/* 偏好设置 */}
      <Drawer
        placement="right"
        width={375}
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        className={`
                   ${
                     themeProperty === ThemeEnum.black
                       ? "drawer_box dark"
                       : "drawer_box white"
                   }`}
        push={false}
        style={{ zIndex: 10009 }}
      >
        <SettingDialog
          theme={themeState}
          onClose={() => setDrawerVisible(false)}
        />
      </Drawer>
    </>
  );
};

export default Header;
